import { TABLE_FIELDS } from 'utils/common-constants';
import { ExtendedColDef } from 'interfaces/table.interface';

export const RUN_ORCHESTRATIONS_TABLE_COLUMNS: ExtendedColDef[] = [
  {
    cellClass: 'csb-visible-tooltip',
    cellRenderer: 'cellWorkflowName',
    comparator: (a: string, b: string) =>
      a?.toLocaleLowerCase()?.localeCompare(b?.toLocaleLowerCase()),
    field: TABLE_FIELDS.name,
    headerName: 'Orchestration Name',
    hide: true,
    maxWidth: 330,
    menuTabs: [],
    minWidth: 330,
    resizable: false,
    suppressHeaderMenuButton: true,
  },
  {
    autoHeight: true,
    field: TABLE_FIELDS.description,
    headerName: 'Orchestration Description',
    menuTabs: [],
    minWidth: 400,
    resizable: false,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: false,
    wrapText: true,
  },
  {
    field: TABLE_FIELDS.worker,
    headerName: 'Worker',
    maxWidth: 150,
    menuTabs: [],
    minWidth: 150,
    resizable: false,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: false,
  },
  {
    comparator: (a, b) => a - b,
    field: TABLE_FIELDS.throttleRate,
    headerName: 'Throttle Rate',
    maxWidth: 140,
    menuTabs: [],
    minWidth: 140,
    resizable: false,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: false,
  },
  {
    field: TABLE_FIELDS.status,
    headerName: 'Status',
    maxWidth: 80,
    menuTabs: [],
    minWidth: 80,
    resizable: false,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: false,
  },
  {
    cellClass: 'csb-visible-cell',
    cellRenderer: 'cellOptions',
    field: TABLE_FIELDS.options,
    headerName: '',
    maxWidth: 60,
    menuTabs: [],
    minWidth: 60,
    resizable: false,
    suppressHeaderMenuButton: true,
    suppressSizeToFit: false,
  },
];

export enum VIEW_OPTIONS {
  COLUMN_VIEW = 'columnView',
  LIST_VIEW = 'listView',
  SPLIT_VIEW = 'splitView',
}

export enum PROPERTIES_PANEL_OPTIONS {
  RUN_ORCHESTRATION = 'run_orchestration',
}
